module.exports = __webpack_public_path__ + "static/media/volume-mute.80b45631.svg";